<template>
    <QuillEditor v-model:content="value" contentType="html" :modules="modules" theme="snow" toolbar="full" />
    <div style="color: rgb(176,0,32); font-size: 12px; margin-left: 4px;">{{ errorMessage }}</div>
</template>

<script setup>

import { useField }    from 'vee-validate';
import { QuillEditor } from '@vueup/vue-quill';
import BlotFormatter   from 'quill-blot-formatter';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

const modules = {
    name: 'blotFormatter',  
    module: BlotFormatter, 
    options: {/* options */}
}

const props = defineProps({name: String,});

// The `name` is returned in a function because we want to make sure it stays reactive
// If the name changes you want `useField` to be able to pick it up
const { value, errorMessage } = useField(() => props.name);

</script>